<div class="Flexbox__flex-1">
<!--  <div class="results-pane-subheader">Navican - Specimen Info</div>-->
  <gen-editable-parameter [isEditableField]="false" [title]="'Specimen ID:'" [value]="sample.identifiers[0]"
                          [invalid]="markInvalid('identifiers', identifiers.dirty && identifiers.invalid)"
                          [displayTooltip]="true"
                          [required]="true"
                          [ngClass]="{'diff_marker':isInUpdatedFields('identifiers[0]')}"
  >
    <input deep-blur  placeholder="Specimen ID"
           class="form-control fs6_5"
           type="text"
           required
           id="identifiers-input{{index}}"
           [pattern]="'^([A-Za-z0-9]([A-Za-z0-9-]*[A-Za-z0-9])?[._-])*([A-Za-z0-9]+)$'"
           #identifiers="ngModel"
           (ngModelChange)="tumorChanged = identifiers.valid"
           (focus)="previousValue = sample.identifiers[0]"
           (blur)="tumorChanged?modelChange($event,sample,'identifiers[0]',true):resetValue(identifiers.name)"
           [(ngModel)]="sample.identifiers[0]"
           name="identifiers[0]"/></gen-editable-parameter>

  <gen-editable-parameter [isEditableField]="!disabledForced" [title]="'External Specimen ID:'" [value]="sample.externalId" [required]="true"
                          [ngClass]="{'diff_marker':isInUpdatedFields('externalId')}"
                          [invalid]="markInvalid('externalId', !sample.externalId)"
  >
    <input deep-blur  placeholder="External identifier"
           class="form-control fs6_5"
           type="text"
           required
           id="sampleExternalId-input{{index}}"
           #externalId="ngModel"
           (ngModelChange)="tumorChanged = externalId.valid"
           (focus)="previousValue = sample.externalId"
           (blur)="tumorChanged?modelChange($event,sample,'externalId',true):resetValue(externalId.name)"
           [(ngModel)]="sample.externalId"
           name="sample.externalId"/>
  </gen-editable-parameter>
  <gen-editable-parameter [invalid]="markInvalid('type', !sample.type)" [required]="true"
                          [isEditableField]="allowedit" [title]="'Specimen type:'" [value]="sample.type ? sample.type.display :'Required information missing'"
                          [ngClass]="{'diff_marker':isInUpdatedFields('type')}"
  >
    <select deep-blur [(ngModel)]="sample.type" class="form-control fs6_5"
            [compareWith]="compareBy" id="specimenType-input{{index}}" required name="specimenType{{index}}"
            (change)="modelChange($event,sample,'type',true);">
      <option [ngValue]="null">- Not Selected -</option>
      <option *ngFor="let st of collectionsData.specimenTypes; trackBy: trackByFn" [ngValue]="st">{{st.display}}</option>
    </select>
  </gen-editable-parameter>
  <gen-editable-parameter [invalid]="markInvalid('site', !sample.site)" [required]="true" [isEditableField]="allowedit"
                          [title]="'Site Of The Tumor:'" [value]="sample.site ? sample.site.display :'Required information missing'"
                          (clickOutside)="allowedit && modelChange({target:selectedAutoComplete},sample,'site',true);"
                          [attachOutsideOnClick]="true"
                          [excludeBeforeClick]="true"
                          [exclude]="'.p-autocomplete-token,.p-autocomplete-item,.p-autocomplete-items,.p-autocomplete-panel,.p-autocomplete-token-icon,.p-autocomplete-token-icon:before'"
                          [ngClass]="{'diff_marker':isInUpdatedFields('site')}"
  >
    <p-autoComplete required deep-blur placeholder="Site" inputId="site-input{{index}}" inputStyleClass="form-control" [appendTo]="'body'"
                    [suggestions]="sites" (completeMethod)="getSites($event)" forceSelection="true"  [(ngModel)]="sample.site"
                    (onFocus)="onAutoFocus($event)"
                     field="display" [minLength]="0" >
    </p-autoComplete>
  </gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="allowedit" [title]="'Collection method:'" [required]="true" [value]="sample.collection.method ? sample.collection.method.display :''"
                          [ngClass]="{'diff_marker':isInUpdatedFields('collection.method')}"
  >
    <select deep-blur [(ngModel)]="sample.collection.method" class="form-control fs6_5" [compareWith]="compareBy"
            id="specimenCollection-input{{index}}" (change)="modelChange($event,sample,'collection.method',false);">
      <option [ngValue]="null">- Not Selected -</option>
      <option *ngFor="let cm of collectionsData.specimenCollections; trackBy: trackByFn" [ngValue]="cm">{{cm.display}}</option>
    </select>
  </gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="!disabledForced" [title]="'Specimen Collection Date:'" [value]="sample.collection.collectedDateTime | date:'dd MMM yyyy'"
                          [invalid]="markInvalid('collection.collectedDateTime', !sample.collection.collectedDateTime)"
                          (clickOutside)="!disabledForced && onDateSelect(sample,'collection.collectedDateTime', true);"
                          [attachOutsideOnClick]="true"
                          [excludeBeforeClick]="true"
                          [required]="true"
                          [exclude]="'.p-datepicker-trigger,.p-datepicker'"
                          [ngClass]="{'diff_marker':isInUpdatedFields('collection.collectedDateTime')}"
  >
    <p-calendar tabindex="-1" deep-blur id="specimenCollectedDateTime-input{{index}}"
                icon="icon__Calendar"
                panelStyleClass="hide-month-nav"
                showButtonBar="true" [inputStyleClass]="'form-control Auto_Specimen_Collection_Date_Input'"
                [(ngModel)]="sample.collection.collectedDateTime"
                [showIcon]="true" dateFormat="dd M yy"
                placeholder="Select date (e.g: 08 Feb 1974)"
                dataType="string"
                (onSelect)="setTime(sample.collection.collectedDateTime)"
                (onFocus)="onFocus($event)" [monthNavigator]="true"
                [yearNavigator]="true"  yearRange="1900:2100">
    </p-calendar>
  </gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="allowedit" [title]="'Shipper ID:'" [value]="sample.shipperId ?  sample.shipperId  :''"
                          [ngClass]="{'diff_marker':isInUpdatedFields('shipperId')}"
  >
    <input deep-blur  placeholder="Shipper ID" class="form-control fs6_5" type="text"
           id="shipperId-input{{index}}"
           (ngModelChange)="shipperChanged = true"
           (blur)="shipperChanged?modelChange($event,sample,'shipperId', false):null"
           [(ngModel)]="sample.shipperId"
           name="shipperId{{index}}"/>
  </gen-editable-parameter>
</div>
<div class="Flexbox__flex-1 Spacebox__l-small">
  <!--<div class="Flexbox results-pane-subheader">Navican - Sample Info</div>-->
  <gen-editable-parameter *ngIf="sample.complete" [isEditableField]="false"
                          [title]="'ID / Lab Accession #:'"
                          [value]="sample.accessionIdentifier.value"
                          ></gen-editable-parameter>
  <gen-editable-parameter *ngIf="sample.complete" [isEditableField]="false" [title]="'FlowCell ID:'" [value]="sample.flowCellId" ></gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="false" [title]="'Status:'" [value]="sample.status" ></gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="allowedit" [title]="'Sample Received Date:'" [value]="sample.receivedTime | date:'dd MMM yyyy'"
                          (clickOutside)="allowedit && onDateSelect(sample,'receivedTime', true);"
                          [invalid]="markInvalid('receivedTime', !sample.receivedTime)"
                          [attachOutsideOnClick]="true"
                          [excludeBeforeClick]="true"
                          [required]="true"
                          [exclude]="'.p-datepicker-trigger,.p-datepicker'"
                          [ngClass]="{'diff_marker':isInUpdatedFields('receivedTime')}"
  >
    <p-calendar tabindex="-1" deep-blur id="specimenReceivedTime-input{{index}}"
                icon="icon__Calendar"
                panelStyleClass="hide-month-nav"
                showButtonBar="true" [inputStyleClass]="'form-control Auto_Sample_Received_Date_Input'"
                [(ngModel)]="sample.receivedTime"
                placeholder="Select date (e.g: 08 Feb 1974)"
                dataType="string"
                [showIcon]="true" dateFormat="dd M yy"
                (onFocus)="onFocus($event)" [monthNavigator]="true"
                [yearNavigator]="true"  yearRange="1900:2100">
    </p-calendar>
  </gen-editable-parameter>
  <gen-editable-parameter [invalid]="markInvalid('tumorPercentage', sample.tumorPercentage && (sample.tumorPercentage<1 ||sample.tumorPercentage>100))"
                          [isEditableField]="allowedit" [title]="'Tumor percentage:'" [value]="sample.tumorPercentage ?  sample.tumorPercentage.toString() + '%'  :''"
                          [ngClass]="{'diff_marker':isInUpdatedFields('tumorPercentage')}"
  >
    <input deep-blur  placeholder="1 - 100 (%)" class="form-control fs6_5" type="number"
           id="tumorPercentage-input{{index}}"
           (ngModelChange)="tumorChanged = true"
           (blur)="tumorChanged?modelChange($event,sample,'tumorPercentage', false):null"
           [(ngModel)]="sample.tumorPercentage" min="1" max="100"
           name="tumorPercentage{{index}}"/>
  </gen-editable-parameter>
  <gen-editable-parameter [invalid]="markInvalid('histopathology', !sample.histopathology)"
                          [required]="true" [isEditableField]="allowedit"
                          [title]="'Histopathology:'" [value]="sample.histopathology ? sample.histopathology.display :'Required information missing'"
                          (clickOutside)="allowedit && modelChange({target:selectedAutoComplete},sample,'histopathology',true);"
                          [attachOutsideOnClick]="true"
                          [excludeBeforeClick]="true"
                          [exclude]="'.p-autocomplete-token,.p-autocomplete-item,.p-autocomplete-items,.p-autocomplete-panel,.p-autocomplete-token-icon,.p-autocomplete-token-icon:before'"
                          [ngClass]="{'diff_marker':isInUpdatedFields('histopathology')}"
  >
    <p-autoComplete deep-blur placeholder="Histopathology" required inputId="histopathology-input{{index}}" inputStyleClass="form-control" [appendTo]="'body'"
                    [suggestions]="histopatologies" (completeMethod)="getHistopathologies($event)" forceSelection="true"
                    field="display" [minLength]="0" (onFocus)="onAutoFocus($event)" [(ngModel)]="sample.histopathology">
    </p-autoComplete>
  </gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="allowedit"
                         [title]="'Printer:'" [value]="sample.printer?sample.printer.display:''"
                          [ngClass]="{'diff_marker':isInUpdatedFields('printer')}"
  >
    <select required deep-blur [(ngModel)]="sample.printer" class="form-control fs6_5" [compareWith]="compareBy"
            id="printer-input{{index}}" (change)="modelChange($event,sample,'printer',false);">
      <option [ngValue]="null">- Not Selected -</option>
      <option *ngFor="let tg of collectionsData.printers; trackBy: trackByFn" [ngValue]="tg">{{tg.display}}</option>
    </select>
  </gen-editable-parameter>
  <gen-editable-parameter [isEditableField]="allowedit" [title]="'Specimen Returned To Lab:'" [value]="sample.returned != null ? (sample.returned ? 'Yes' : 'No') :''"
                          [ngClass]="{'diff_marker':isInUpdatedFields('returned')}"
  >
    <select  deep-blur [(ngModel)]="sample.returned" class="form-control fs6_5"
             id="returned-input{{index}}" (change)="modelChange($event,sample,'returned',false);">
      <option [ngValue]="null">- Not Selected -</option>
      <option [ngValue]="true">Yes</option>
      <option [ngValue]="false">No</option>
    </select>
  </gen-editable-parameter>
  <gen-editable-parameter [valueStyle]="{'white-space': 'pre-line'}" [isEditableField]="allowedit" [title]="'Specimen Notes:'" [value]="sample.returnNotes ? sample.returnNotes :''"
                          [ngClass]="{'diff_marker':isInUpdatedFields('returnNotes')}"
  >
    <textarea deep-blur rows="5"
              placeholder="Notes"
              class="form-control fs6_5"
              [(ngModel)]="sample.returnNotes"
              id="returnNotes-input{{index}}"
              (ngModelChange)="returnNotesChanged = true"
              (blur)="returnNotesChanged?modelChange($event,sample,'returnNotes',false):null"></textarea>
  </gen-editable-parameter>
</div>
<span class="flag " [ngClass]="{'invalid':!sample.isInvalid,'valid':sample.isInvalid}"
      (click)="sample.isInvalid = !sample.isInvalid; modelChange($event,sample);">Flag as {{sample.isInvalid?"Valid":"Invalid"}}</span>
